import { FormDialog } from "@/ui/form-dialog";
import { ReadonlyTextField } from "@/ui/inputs";
import { Paragraphs } from "@/ui/paragraphs";
import { button, paragraph } from "@/ui/utils.css";
import { DialogStore } from "@ariakit/react";
import { ShareButton } from "@indietabletop/appkit";
import { QRCode } from "../qr-code";

export function ShareDialog(props: {
  inputValue: string;
  shareData: { title: string; url: string } | null;
  heading: string;
  text: string;
  store: DialogStore;
}) {
  return (
    <FormDialog store={props.store} heading={props.heading} submit="Done">
      <div style={{ marginBottom: "2.5rem" }}>
        <Paragraphs text={props.text} />
      </div>

      <div style={{ display: "grid", gap: "0.75rem" }}>
        <ReadonlyTextField value={props.inputValue} label="Share Link" />
        <ShareButton
          copyLabel="Copy share link"
          shareLabel="Share link"
          shareData={props.shareData}
          className={button}
        />
      </div>

      <div
        style={{
          fontSize: "1rem",
          fontStyle: "italic",
          textAlign: "center",
          margin: "2rem 0",
        }}
      >
        — or —
      </div>

      <div
        style={{
          backgroundColor: "hsl(0 0% 0% / 0.05)",
          borderRadius: "0.5rem",
          textAlign: "center",
          padding: "2rem",
        }}
      >
        {props.shareData && <QRCode url={props.shareData.url} />}

        <p
          className={paragraph}
          style={{
            maxWidth: "20rem",
            textWrap: "balance",
            margin: "0 auto",
            fontStyle: "italic",
          }}
        >
          Let others scan this QR code with a camera to share in person.
        </p>
      </div>
    </FormDialog>
  );
}
